import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


/* This view is used to display a message at the top of the coachhub page */
export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'render', 'hide', 'show_profile_tip');
    this.profileTipTmpl = _.template($('#profile-tip-tmpl').html());
    this.contacts = options.coachhub.contacts;
    this.render();
    // When profile modal is closed, hide this tip
    $('#profileModal').on('hidden.bs.modal', this.hide);
  },
  hide: function () {
    // Clear any existing message
    $('.mh-alert', this.el).remove();
    this.trigger('notified');
  },
  render: function () {
    if (!this.contacts || this.contacts.length == 0) {
      this.hide();
    } else {
      this.show_profile_tip();
    }
  },
  show_profile_tip: function () {
    this.$el.html(this.profileTipTmpl({}));
  }
});



// WEBPACK FOOTER //
// ./static/js/views/profile_message.js